module.exports = __webpack_public_path__ + "static/img/home8.3f29c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home8.jpg
// module id = N4lx
// module chunks = 0